import { Region } from 'types/region'
import { FixedPrices, SimulatePriceResponse, SimulationSteps } from 'features/simulation/types'
import { PromoCode } from 'types/promo-referral-codes'

export type SimulationStore = {
  isLoading: boolean
  error: boolean
  currentStep: SimulationSteps
  region?: Region
  didSimulation: boolean
  promoCode?: PromoCode
  visible: boolean
  contactMe: boolean
  price?: SimulatePriceResponse
  fixedPrices?: FixedPrices
  inputs: SimulationInputs
  simulationFlow: SimulationSteps[]
}

export type SimulationInputs = {
  [key in SimulationInputKeys]: any
}

export enum SimulationInputKeys {
  REGION = 'region',
  HAS_VAT = 'hasVat',
  HAS_SOLAR_PANELS = 'hasSolarPanels',
  COUNTER_TYPE = 'counterType',
  SOLAR_POWER = 'solarPower',
  SOLAR_PANELS = 'solarPanels',
  NEEDS_GAS = 'needsGas',
  KNOWS_USAGE = 'knowsUsage',
  METER_TYPE = 'meterType',
  HAS_EXCLUSIVE_NIGHT_METER = 'hasExclusiveNightMeter',
  BUILDING_TYPE = 'buildingType',
  RESIDENTS = 'residents',
  USAGE = 'usage',
  FIRSTNAME = 'firstname',
  LASTNAME = 'lastname',
  EMAIL = 'email',
  PHONE = 'phone',
  PERMISSION = 'permission',
  PRICE_WITHOUT_PROMO = 'priceWithoutPromo',
  EXTRA_INSTALMENT = 'extraInstalment',
  ELECTRICITY_PRODUCT = 'electricityProduct',
  GAS_PRODUCT = 'gasProduct',
  DELIVERY_POINT = 'deliveryPoint',
  HAUGAZEL_PRODUCTS = 'haugazelProducts',
  USAGE_TYPE = 'usageType',
  REFERRAL_CODE = 'referralCode',
  PROMO_CODE = 'promoCode'
}
